import { Link } from 'react-router-dom';
import { AnimatedBackground } from '../components/AnimatedBackground.jsx';

/** Rota `*` dentro da SPA (URL não existe no router ou link quebrado). */
export function NotFoundPage() {
  return (
    <div className="relative grid min-h-screen place-items-center overflow-x-hidden px-4">
      <AnimatedBackground />

      <div className="relative z-10 w-full max-w-md text-center">
        <Link
          to="/"
          className="mb-8 inline-flex flex-col items-center gap-2 rounded-2xl text-zinc-900 dark:text-zinc-100"
        >
          <img src="/logo-ominia-hub-ring.svg" alt="" width={52} height={52} className="drop-shadow-md" />
          <span className="font-display text-lg font-bold">
            <span className="text-gradient">Omin</span>
            <span className="text-gradient-ia">IA</span>
          </span>
        </Link>

        <p className="font-mono text-6xl font-bold tabular-nums text-zinc-300/70 dark:text-zinc-700/70">404</p>
        <h1 className="mt-3 font-display text-2xl font-bold text-zinc-900 dark:text-zinc-50">
          Esta página não existe
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-zinc-600 dark:text-zinc-400">
          Confirme o link ou navegue até a página inicial.
        </p>

        <div className="mt-10 flex flex-col items-center gap-3">
          <Link
            to="/"
            className="inline-flex rounded-full bg-zinc-900 px-8 py-3 text-xs font-bold uppercase tracking-widest text-white shadow-lg hover:-translate-y-0.5 dark:bg-accent"
          >
            Voltar ao site
          </Link>
          <Link to="/cadastro" className="text-sm font-medium text-emerald-700 hover:underline dark:text-emerald-400">
            Criar conta
          </Link>
        </div>
      </div>
    </div>
  );
}
